import React, { useState, forwardRef } from 'react'
import propTypes from 'prop-types'
import { Tooltip as MuiTooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

const setSize = makeStyles({
  tooltip: {
    maxWidth: width => width || 300,
    padding: "8px 10px",
    fontSize: "0.875rem",
  }
});

export const Tooltip = forwardRef(({ children, title, width }, ref) => {

  const tooltipClasses = setSize(width)

  return (
    <MuiTooltip
      ref={ref}
      classes={{ tooltip: tooltipClasses.tooltip }}
      title={title}
    >
      <Box style={{ display: 'inline-block'}}>
        { children }
      </Box>
    </MuiTooltip>
  )
})

Tooltip.propTypes = {
  title: propTypes.node.isRequired,
  width: propTypes.number
}
